import script from "./Success.vue?vue&type=script&setup=true&lang=ts"
export * from "./Success.vue?vue&type=script&setup=true&lang=ts"

import "./Success.vue?vue&type=style&index=0&id=e69c8ea2&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e69c8ea2"]])

export default __exports__